import { cx } from "class-variance-authority";
import { Boxes } from "lucide-react";
import { FC } from "react";
interface GroupIconProps {
	className?: string;
}
export const GroupIcon: FC<GroupIconProps> = ({ className }) => <Boxes className={cx("h-3 w-3", className)} />;
